import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./approved-service.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./approved-service.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ApprovedServiceEffects {

  getNotApprovedServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllApprovedServices),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_INSTITUTION_SERVICE,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadApprovedServices({ approvedServices: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
